export default __webpack_public_path__ + "static/media/T50.caf791bb.JPG";